
import { useState } from "react";
import "../Loginpage/loginpage.css";


const Login = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault()
    window.location.href = "/dashboard";

  }
  return (
    <>
      <section>
        <div className="page-header section-height-75">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">
                <div className=" card-style shadow-10 mt-5 mt-xl-5 mb-4 ">
                  <div className="p-3 text-center bg-transparent">
                    <img
                      className="mb-2"
                      src="/img/logo.png"
                      alt="..."
                      style={{ height: "58px" }}
                    />
                    <h5
                      className="font-weight-bolder text-white"

                    >
                      Login
                    </h5>
                    <p className="mb-0 card-descp">
                      Enter your email and password to sign in
                    </p>
                  </div>
                  <div className="card-body">
                    <form role="form text-left">
                      <label className="login-label">Email</label>
                      <div className="mb-3">
                        <input
                          value={email}
                          type="email"
                          className="form-control input-style"
                          placeholder="Email"
                          aria-label="Email"
                          aria-describedby="email-addon"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <label className="login-label">Password</label>
                      <div className="mb-3">
                        <input
                          value={password}
                          type="password"
                          className="form-control input-style"
                          placeholder="Password"
                          aria-label="Password"
                          aria-describedby="password-addon"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="d-flex mt-4 justify-content-between">
                        <button
                          type="button"
                          className="btn submit-btn text-white"
                          onClick={handleLogin}
                          style={{
                            width: "100%",
                          }}
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};


export default Login;
